export default __webpack_public_path__ + "static/media/presto.54dcf53a.svg";